export default class HoldQiDetails {
    qiDetailId: number;
    holdTicketId: number;
    location: string;
    quantity: number;
    qiHold:number;

    constructor(){
        this.qiDetailId = 0;
        this.holdTicketId = 0;
        this.location = "";
        this.quantity = 0;
        this.qiHold = 0;
    }
}